module.exports = __webpack_public_path__ + "static/dining.4cade79f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/dining.jpg
// module id = 518
// module chunks = 152909308826437